import {Box} from 'src/design/atoms/Box';
import {Divider} from 'src/design/atoms/Divider';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {Link} from 'react-router-dom';
import {RoleEnum} from 'src/api/ProactApiClient';
import {Button} from 'src/design/atoms/Button';
import {Title} from 'src/design/atoms/Title';
import {useAppSelector} from 'src/redux/hooks';
import {PathUtility} from 'src/shared/constants/PathBuilder';

import {routeRegistry} from 'src/pages/RouteRegistry';

const PermissionDeniedPage = () => {
  const {session} = useAppSelector(state => state.session);

  let message = 'Please contact your administrator to request access.';
  let access = true;
  if (!session?.user) {
    message = 'Your account is not configured to access this application.';
    access = false;
  } else if (session?.user?.roleId == RoleEnum.NotificationOnly) {
    message =
      'Your account is configured to only receive notifications from this application. Your account is not configured to access this application. Please contact your administrator for support.';
    access = false;
  }
  return (
    <Stack mt="md" gap="md">
      <Title>Oops, you don't have permissions to access that.</Title>
      <Divider />
      <Text>{message}</Text>
      {access && (
        <Box>
          <Button component={Link} size="lg" to={PathUtility.Dashboard()}>
            Return to dashboard
          </Button>
        </Box>
      )}
      {!access && (
        <Box>
          <Button component={Link} size="lg" to={PathUtility.Logout()}>
            Sign Out
          </Button>
        </Box>
      )}
    </Stack>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.PermissionDenied(),
  element: <PermissionDeniedPage />,
  isPrivate: false,
});

export default PermissionDeniedPage;
